var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
        },
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-card",
          staticStyle: {
            "min-width": "50vw",
            width: "fit-content",
            "min-height": "80vh",
            height: "fit-content",
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title" }, [
              _vm._v(" New Movement "),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "1rem",
                    "text-overflow": "elipsis",
                  },
                },
                [_vm._v(_vm._s(_vm.plant.name))]
              ),
            ]),
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _c(
                "b-field",
                { attrs: { grouped: "" } },
                [
                  _c(
                    "b-field",
                    { attrs: { label: "Shift" } },
                    [
                      _c(
                        "b-select",
                        {
                          attrs: { placeholder: "Shift" },
                          model: {
                            value: _vm.shift,
                            callback: function ($$v) {
                              _vm.shift = $$v
                            },
                            expression: "shift",
                          },
                        },
                        [
                          _c("option", { attrs: { value: "AM" } }, [
                            _vm._v(" AM "),
                          ]),
                          _c("option", { attrs: { value: "PM" } }, [
                            _vm._v(" PM "),
                          ]),
                          _c("option", { attrs: { value: "Night" } }, [
                            _vm._v(" Night "),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "Activity" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type:
                              _vm.operation == "washing"
                                ? "is-success"
                                : "is-light",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeActivity("washing")
                            },
                          },
                        },
                        [_vm._v(" Manual Washing ")]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type:
                              _vm.operation == "machineWash"
                                ? "is-success"
                                : "is-light",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeActivity("machineWash")
                            },
                          },
                        },
                        [_vm._v(" Machine Washing ")]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type:
                              _vm.operation == "repair"
                                ? "is-success"
                                : "is-light",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeActivity("repair")
                            },
                          },
                        },
                        [_vm._v(" Repair ")]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type:
                              _vm.operation == "quality"
                                ? "is-success"
                                : "is-light",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeActivity("quality")
                            },
                          },
                        },
                        [_vm._v(" Random Control ")]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type:
                              _vm.operation == "forklift"
                                ? "is-success"
                                : "is-light",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeActivity("forklift")
                            },
                          },
                        },
                        [_vm._v(" Forklift ")]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type:
                              _vm.operation == "special"
                                ? "is-success"
                                : "is-light",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeActivity("special")
                            },
                          },
                        },
                        [_vm._v(" Special ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "Crate Type" } },
                    [
                      _c(
                        "b-select",
                        {
                          attrs: { placeholder: "Crate Type" },
                          model: {
                            value: _vm.crateType,
                            callback: function ($$v) {
                              _vm.crateType = $$v
                            },
                            expression: "crateType",
                          },
                        },
                        [
                          _c("option", { attrs: { value: "1" } }, [
                            _vm._v(" 1 "),
                          ]),
                          _c("option", { attrs: { value: "5.1" } }, [
                            _vm._v(" 5.1 "),
                          ]),
                          _c(
                            "option",
                            { attrs: { value: "5.2", selected: "" } },
                            [_vm._v(" 5.2 ")]
                          ),
                          _c("option", { attrs: { value: "5.5" } }, [
                            _vm._v(" 5.5 "),
                          ]),
                          _c("option", { attrs: { value: "GPSFood" } }, [
                            _vm._v(" GPS Food "),
                          ]),
                          _c("option", { attrs: { value: "ZEON" } }, [
                            _vm._v(" ZEON "),
                          ]),
                          _c("option", { attrs: { value: "RHODIA" } }, [
                            _vm._v(" RHODIA "),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.operation != null
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        { staticClass: "mb-1", attrs: { grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Date" } },
                            [
                              _c("b-datepicker", {
                                attrs: {
                                  name: "date",
                                  "first-day-of-week": 1,
                                  locale: "en-CA",
                                  icon: "calendar-alt",
                                  placeholder: "Date",
                                },
                                model: {
                                  value: _vm.date,
                                  callback: function ($$v) {
                                    _vm.date = $$v
                                  },
                                  expression: "date",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.operation === "washing" && _vm.shift === "AM"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-field",
                                    { attrs: { label: "Hours" } },
                                    [
                                      _c("b-input", {
                                        attrs: {
                                          type: "number",
                                          step: "0.01",
                                          min: "0",
                                        },
                                        model: {
                                          value: _vm.amWashingHours,
                                          callback: function ($$v) {
                                            _vm.amWashingHours = $$v
                                          },
                                          expression: "amWashingHours",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.operation === "washing" && _vm.shift === "PM"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-field",
                                    { attrs: { label: "Hours" } },
                                    [
                                      _c("b-input", {
                                        attrs: {
                                          type: "number",
                                          step: "0.01",
                                          min: "0",
                                        },
                                        model: {
                                          value: _vm.pmWashingHours,
                                          callback: function ($$v) {
                                            _vm.pmWashingHours = $$v
                                          },
                                          expression: "pmWashingHours",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.operation === "washing" && _vm.shift === "Night"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-field",
                                    { attrs: { label: "Hours" } },
                                    [
                                      _c("b-input", {
                                        attrs: {
                                          type: "number",
                                          step: "0.01",
                                          min: "0",
                                        },
                                        model: {
                                          value: _vm.nightWashingHours,
                                          callback: function ($$v) {
                                            _vm.nightWashingHours = $$v
                                          },
                                          expression: "nightWashingHours",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.operation === "machineWash" && _vm.shift === "AM"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-field",
                                    { attrs: { label: "Hours" } },
                                    [
                                      _c("b-input", {
                                        attrs: {
                                          type: "number",
                                          step: "0.01",
                                          min: "0",
                                        },
                                        model: {
                                          value: _vm.amMachineHours,
                                          callback: function ($$v) {
                                            _vm.amMachineHours = $$v
                                          },
                                          expression: "amMachineHours",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.operation === "machineWash" && _vm.shift === "PM"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-field",
                                    { attrs: { label: "Hours" } },
                                    [
                                      _c("b-input", {
                                        attrs: {
                                          type: "number",
                                          step: "0.01",
                                          min: "0",
                                        },
                                        model: {
                                          value: _vm.pmMachineHours,
                                          callback: function ($$v) {
                                            _vm.pmMachineHours = $$v
                                          },
                                          expression: "pmMachineHours",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.operation === "machineWash" &&
                          _vm.shift === "Night"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-field",
                                    { attrs: { label: "Hours" } },
                                    [
                                      _c("b-input", {
                                        attrs: {
                                          type: "number",
                                          step: "0.01",
                                          min: "0",
                                        },
                                        model: {
                                          value: _vm.nightMachineHours,
                                          callback: function ($$v) {
                                            _vm.nightMachineHours = $$v
                                          },
                                          expression: "nightMachineHours",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.operation === "forklift" && _vm.shift === "AM"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-field",
                                    { attrs: { label: "Hours" } },
                                    [
                                      _c("b-input", {
                                        attrs: {
                                          type: "number",
                                          step: "0.01",
                                          min: "0",
                                        },
                                        model: {
                                          value: _vm.amForkliftHours,
                                          callback: function ($$v) {
                                            _vm.amForkliftHours = $$v
                                          },
                                          expression: "amForkliftHours",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.operation === "forklift" && _vm.shift === "PM"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-field",
                                    { attrs: { label: "Hours" } },
                                    [
                                      _c("b-input", {
                                        attrs: {
                                          type: "number",
                                          step: "0.01",
                                          min: "0",
                                        },
                                        model: {
                                          value: _vm.pmForkliftHours,
                                          callback: function ($$v) {
                                            _vm.pmForkliftHours = $$v
                                          },
                                          expression: "pmForkliftHours",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.operation === "forklift" && _vm.shift === "Night"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-field",
                                    { attrs: { label: "Hours" } },
                                    [
                                      _c("b-input", {
                                        attrs: {
                                          type: "number",
                                          step: "0.01",
                                          min: "0",
                                        },
                                        model: {
                                          value: _vm.nightForkliftHours,
                                          callback: function ($$v) {
                                            _vm.nightForkliftHours = $$v
                                          },
                                          expression: "nightForkliftHours",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.operation === "special" && _vm.shift === "AM"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-field",
                                    { attrs: { label: "Hours" } },
                                    [
                                      _c("b-input", {
                                        attrs: {
                                          type: "number",
                                          step: "0.01",
                                          min: "0",
                                        },
                                        model: {
                                          value: _vm.amSpecialHours,
                                          callback: function ($$v) {
                                            _vm.amSpecialHours = $$v
                                          },
                                          expression: "amSpecialHours",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.operation === "special" && _vm.shift === "PM"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-field",
                                    { attrs: { label: "Hours" } },
                                    [
                                      _c("b-input", {
                                        attrs: {
                                          type: "number",
                                          step: "0.01",
                                          min: "0",
                                        },
                                        model: {
                                          value: _vm.pmSpecialHours,
                                          callback: function ($$v) {
                                            _vm.pmSpecialHours = $$v
                                          },
                                          expression: "pmSpecialHours",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.operation === "special" && _vm.shift === "Night"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-field",
                                    { attrs: { label: "Hours" } },
                                    [
                                      _c("b-input", {
                                        attrs: {
                                          type: "number",
                                          step: "0.01",
                                          min: "0",
                                        },
                                        model: {
                                          value: _vm.nightSpecialHours,
                                          callback: function ($$v) {
                                            _vm.nightSpecialHours = $$v
                                          },
                                          expression: "nightSpecialHours",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.operation === "washing" && _vm.shift === "AM"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        { attrs: { label: "Quantity washed successfully" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.amWashedClean,
                              callback: function ($$v) {
                                _vm.amWashedClean = $$v
                              },
                              expression: "amWashedClean",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Quantity rejected dirty" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.amWashedDirty,
                              callback: function ($$v) {
                                _vm.amWashedDirty = $$v
                              },
                              expression: "amWashedDirty",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Quantity rejected to repair" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.amWashedRepair,
                              callback: function ($$v) {
                                _vm.amWashedRepair = $$v
                              },
                              expression: "amWashedRepair",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Comment" } },
                        [
                          _c("b-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.amWashingComment,
                              callback: function ($$v) {
                                _vm.amWashingComment = $$v
                              },
                              expression: "amWashingComment",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.operation === "washing" && _vm.shift === "PM"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        { attrs: { label: "Quantity washed successfully" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.pmWashedClean,
                              callback: function ($$v) {
                                _vm.pmWashedClean = $$v
                              },
                              expression: "pmWashedClean",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Quantity rejected dirty" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.pmWashedDirty,
                              callback: function ($$v) {
                                _vm.pmWashedDirty = $$v
                              },
                              expression: "pmWashedDirty",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Quantity rejected to repair" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.pmWashedRepair,
                              callback: function ($$v) {
                                _vm.pmWashedRepair = $$v
                              },
                              expression: "pmWashedRepair",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Comment" } },
                        [
                          _c("b-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.pmWashingComment,
                              callback: function ($$v) {
                                _vm.pmWashingComment = $$v
                              },
                              expression: "pmWashingComment",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.operation === "washing" && _vm.shift === "Night"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        { attrs: { label: "Quantity washed successfully" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.nightWashedClean,
                              callback: function ($$v) {
                                _vm.nightWashedClean = $$v
                              },
                              expression: "nightWashedClean",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Quantity rejected dirty" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.nightWashedDirty,
                              callback: function ($$v) {
                                _vm.nightWashedDirty = $$v
                              },
                              expression: "nightWashedDirty",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Quantity rejected to repair" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.nightWashedRepair,
                              callback: function ($$v) {
                                _vm.nightWashedRepair = $$v
                              },
                              expression: "nightWashedRepair",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Comment" } },
                        [
                          _c("b-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.nightWashingComment,
                              callback: function ($$v) {
                                _vm.nightWashingComment = $$v
                              },
                              expression: "nightWashingComment",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.operation === "machineWash" && _vm.shift === "AM"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        { attrs: { label: "Quantity washed successfully" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.amMachineClean,
                              callback: function ($$v) {
                                _vm.amMachineClean = $$v
                              },
                              expression: "amMachineClean",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Quantity rejected dirty" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.amMachineDirty,
                              callback: function ($$v) {
                                _vm.amMachineDirty = $$v
                              },
                              expression: "amMachineDirty",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Quantity rejected to repair" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.amMachineRepair,
                              callback: function ($$v) {
                                _vm.amMachineRepair = $$v
                              },
                              expression: "amMachineRepair",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Comment" } },
                        [
                          _c("b-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.amMachineComment,
                              callback: function ($$v) {
                                _vm.amMachineComment = $$v
                              },
                              expression: "amMachineComment",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.operation === "machineWash" && _vm.shift === "PM"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        { attrs: { label: "Quantity washed successfully" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.pmMachineClean,
                              callback: function ($$v) {
                                _vm.pmMachineClean = $$v
                              },
                              expression: "pmMachineClean",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Quantity rejected dirty" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.pmMachineDirty,
                              callback: function ($$v) {
                                _vm.pmMachineDirty = $$v
                              },
                              expression: "pmMachineDirty",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Quantity rejected to repair" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.pmMachineRepair,
                              callback: function ($$v) {
                                _vm.pmMachineRepair = $$v
                              },
                              expression: "pmMachineRepair",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Comment" } },
                        [
                          _c("b-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.pmMachineComment,
                              callback: function ($$v) {
                                _vm.pmMachineComment = $$v
                              },
                              expression: "pmMachineComment",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.operation === "machineWash" && _vm.shift === "Night"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        { attrs: { label: "Quantity washed successfully" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.nightMachineClean,
                              callback: function ($$v) {
                                _vm.nightMachineClean = $$v
                              },
                              expression: "nightMachineClean",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Quantity rejected dirty" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.nightMachineDirty,
                              callback: function ($$v) {
                                _vm.nightMachineDirty = $$v
                              },
                              expression: "nightMachineDirty",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Quantity rejected to repair" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.nightMachineRepair,
                              callback: function ($$v) {
                                _vm.nightMachineRepair = $$v
                              },
                              expression: "nightMachineRepair",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Comment" } },
                        [
                          _c("b-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.nightMachineComment,
                              callback: function ($$v) {
                                _vm.nightMachineComment = $$v
                              },
                              expression: "nightMachineComment",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.operation === "repair" && _vm.shift === "AM"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        { attrs: { label: "Crates Repaired", grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Hours" } },
                            [
                              _c("b-input", {
                                attrs: {
                                  type: "number",
                                  step: "0.01",
                                  min: "0",
                                },
                                model: {
                                  value: _vm.amRepairHours,
                                  callback: function ($$v) {
                                    _vm.amRepairHours = $$v
                                  },
                                  expression: "amRepairHours",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Quantity" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.amRepairedCrates,
                                  callback: function ($$v) {
                                    _vm.amRepairedCrates = $$v
                                  },
                                  expression: "amRepairedCrates",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Doors Repaired", grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Hours" } },
                            [
                              _c("b-input", {
                                attrs: {
                                  type: "number",
                                  step: "0.01",
                                  min: "0",
                                },
                                model: {
                                  value: _vm.amDoorHours,
                                  callback: function ($$v) {
                                    _vm.amDoorHours = $$v
                                  },
                                  expression: "amDoorHours",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Quantity" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.amRepairedDoors,
                                  callback: function ($$v) {
                                    _vm.amRepairedDoors = $$v
                                  },
                                  expression: "amRepairedDoors",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Comment" } },
                        [
                          _c("b-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.amRepairComment,
                              callback: function ($$v) {
                                _vm.amRepairComment = $$v
                              },
                              expression: "amRepairComment",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.operation === "repair" && _vm.shift === "PM"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        { attrs: { label: "Crates Repaired", grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Hours" } },
                            [
                              _c("b-input", {
                                attrs: {
                                  type: "number",
                                  step: "0.01",
                                  min: "0",
                                },
                                model: {
                                  value: _vm.pmRepairHours,
                                  callback: function ($$v) {
                                    _vm.pmRepairHours = $$v
                                  },
                                  expression: "pmRepairHours",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Quantity" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.pmRepairedCrates,
                                  callback: function ($$v) {
                                    _vm.pmRepairedCrates = $$v
                                  },
                                  expression: "pmRepairedCrates",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Doors Repaired", grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Hours" } },
                            [
                              _c("b-input", {
                                attrs: {
                                  type: "number",
                                  step: "0.01",
                                  min: "0",
                                },
                                model: {
                                  value: _vm.pmDoorHours,
                                  callback: function ($$v) {
                                    _vm.pmDoorHours = $$v
                                  },
                                  expression: "pmDoorHours",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Quantity" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.pmRepairedDoors,
                                  callback: function ($$v) {
                                    _vm.pmRepairedDoors = $$v
                                  },
                                  expression: "pmRepairedDoors",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Comment" } },
                        [
                          _c("b-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.pmRepairComment,
                              callback: function ($$v) {
                                _vm.pmRepairComment = $$v
                              },
                              expression: "pmRepairComment",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.operation === "repair" && _vm.shift === "Night"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        { attrs: { label: "Crates Repaired", grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Hours" } },
                            [
                              _c("b-input", {
                                attrs: {
                                  type: "number",
                                  step: "0.01",
                                  min: "0",
                                },
                                model: {
                                  value: _vm.nightRepairHours,
                                  callback: function ($$v) {
                                    _vm.nightRepairHours = $$v
                                  },
                                  expression: "nightRepairHours",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Quantity" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.nightRepairedCrates,
                                  callback: function ($$v) {
                                    _vm.nightRepairedCrates = $$v
                                  },
                                  expression: "nightRepairedCrates",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Doors Repaired", grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Hours" } },
                            [
                              _c("b-input", {
                                attrs: {
                                  type: "number",
                                  step: "0.01",
                                  min: "0",
                                },
                                model: {
                                  value: _vm.nightDoorHours,
                                  callback: function ($$v) {
                                    _vm.nightDoorHours = $$v
                                  },
                                  expression: "nightDoorHours",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Quantity" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.nightRepairedDoors,
                                  callback: function ($$v) {
                                    _vm.nightRepairedDoors = $$v
                                  },
                                  expression: "nightRepairedDoors",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Comment" } },
                        [
                          _c("b-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.nightRepairComment,
                              callback: function ($$v) {
                                _vm.nightRepairComment = $$v
                              },
                              expression: "nightRepairComment",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.operation === "quality" && _vm.shift === "AM"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        { attrs: { label: "Good Crates" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.amGoodCrates,
                              callback: function ($$v) {
                                _vm.amGoodCrates = $$v
                              },
                              expression: "amGoodCrates",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Bad Crates" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.amBadCrates,
                              callback: function ($$v) {
                                _vm.amBadCrates = $$v
                              },
                              expression: "amBadCrates",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.amQualityComment,
                                  callback: function ($$v) {
                                    _vm.amQualityComment = $$v
                                  },
                                  expression: "amQualityComment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.operation === "quality" && _vm.shift === "PM"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        { attrs: { label: "Good Crates" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.pmGoodCrates,
                              callback: function ($$v) {
                                _vm.pmGoodCrates = $$v
                              },
                              expression: "pmGoodCrates",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Bad Crates" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.pmBadCrates,
                              callback: function ($$v) {
                                _vm.pmBadCrates = $$v
                              },
                              expression: "pmBadCrates",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.pmQualityComment,
                                  callback: function ($$v) {
                                    _vm.pmQualityComment = $$v
                                  },
                                  expression: "pmQualityComment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.operation === "quality" && _vm.shift === "Night"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        { attrs: { label: "Good Crates" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.nightGoodCrates,
                              callback: function ($$v) {
                                _vm.nightGoodCrates = $$v
                              },
                              expression: "nightGoodCrates",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Bad Crates" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.nightBadCrates,
                              callback: function ($$v) {
                                _vm.nightBadCrates = $$v
                              },
                              expression: "nightBadCrates",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.nightQualityComment,
                                  callback: function ($$v) {
                                    _vm.nightQualityComment = $$v
                                  },
                                  expression: "nightQualityComment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.operation === "forklift" && _vm.shift === "AM"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        {
                          staticClass: "mb-1",
                          attrs: {
                            label: "Dirty",
                            "custom-class": "is-large mb-1",
                            grouped: "",
                          },
                        },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Received" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.amForklift.dirty.received,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.amForklift.dirty,
                                      "received",
                                      $$v
                                    )
                                  },
                                  expression: "amForklift.dirty.received",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Delivered" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.amForklift.dirty.delivered,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.amForklift.dirty,
                                      "delivered",
                                      $$v
                                    )
                                  },
                                  expression: "amForklift.dirty.delivered",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        {
                          staticClass: "mb-1",
                          attrs: {
                            label: "Clean",
                            "custom-class": "is-large mb-1",
                            grouped: "",
                          },
                        },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Received" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.amForklift.clean.received,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.amForklift.clean,
                                      "received",
                                      $$v
                                    )
                                  },
                                  expression: "amForklift.clean.received",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Delivered" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.amForklift.clean.delivered,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.amForklift.clean,
                                      "delivered",
                                      $$v
                                    )
                                  },
                                  expression: "amForklift.clean.delivered",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        {
                          staticClass: "mb-1",
                          attrs: {
                            label: "Repair",
                            "custom-class": "is-large mb-1",
                            grouped: "",
                          },
                        },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Received" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.amForklift.repair.received,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.amForklift.repair,
                                      "received",
                                      $$v
                                    )
                                  },
                                  expression: "amForklift.repair.received",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Delivered" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.amForklift.repair.delivered,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.amForklift.repair,
                                      "delivered",
                                      $$v
                                    )
                                  },
                                  expression: "amForklift.repair.delivered",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Forklift comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.amForkliftComment,
                                  callback: function ($$v) {
                                    _vm.amForkliftComment = $$v
                                  },
                                  expression: "amForkliftComment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        {
                          staticClass: "mb-1",
                          attrs: {
                            label: "Yard",
                            "custom-class": "is-large mb-1",
                            grouped: "",
                          },
                        },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Clean rejected to dirty" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.amForklift.park.cleanRejectedDirty,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.amForklift.park,
                                      "cleanRejectedDirty",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "amForklift.park.cleanRejectedDirty",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Rejected Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value:
                                    _vm.amForklift.park
                                      .cleanRejectedDirtyComment,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.amForklift.park,
                                      "cleanRejectedDirtyComment",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "amForklift.park.cleanRejectedDirtyComment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { staticClass: "mb-1", attrs: { grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Clean rejected to repair" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value:
                                    _vm.amForklift.park.cleanRejectedRepair,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.amForklift.park,
                                      "cleanRejectedRepair",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "amForklift.park.cleanRejectedRepair",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Rejected Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value:
                                    _vm.amForklift.park
                                      .cleanRejectedRepairComment,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.amForklift.park,
                                      "cleanRejectedRepairComment",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "amForklift.park.cleanRejectedRepairComment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { staticClass: "mb-1", attrs: { grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Dirty rejected to repair" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value:
                                    _vm.amForklift.park.dirtyRejectedRepair,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.amForklift.park,
                                      "dirtyRejectedRepair",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "amForklift.park.dirtyRejectedRepair",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Rejected Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value:
                                    _vm.amForklift.park
                                      .dirtyRejectedRepairComment,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.amForklift.park,
                                      "dirtyRejectedRepairComment",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "amForklift.park.dirtyRejectedRepairComment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.operation === "forklift" && _vm.shift === "PM"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        {
                          staticClass: "mb-1",
                          attrs: {
                            label: "Dirty",
                            "custom-class": "is-large mb-1",
                            grouped: "",
                          },
                        },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Received" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.pmForklift.dirty.received,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pmForklift.dirty,
                                      "received",
                                      $$v
                                    )
                                  },
                                  expression: "pmForklift.dirty.received",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Delivered" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.pmForklift.dirty.delivered,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pmForklift.dirty,
                                      "delivered",
                                      $$v
                                    )
                                  },
                                  expression: "pmForklift.dirty.delivered",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        {
                          staticClass: "mb-1",
                          attrs: {
                            label: "Clean",
                            "custom-class": "is-large mb-1",
                            grouped: "",
                          },
                        },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Received" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.pmForklift.clean.received,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pmForklift.clean,
                                      "received",
                                      $$v
                                    )
                                  },
                                  expression: "pmForklift.clean.received",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Delivered" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.pmForklift.clean.delivered,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pmForklift.clean,
                                      "delivered",
                                      $$v
                                    )
                                  },
                                  expression: "pmForklift.clean.delivered",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        {
                          staticClass: "mb-1",
                          attrs: {
                            label: "Repair",
                            "custom-class": "is-large mb-1",
                            grouped: "",
                          },
                        },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Received" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.pmForklift.repair.received,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pmForklift.repair,
                                      "received",
                                      $$v
                                    )
                                  },
                                  expression: "pmForklift.repair.received",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Delivered" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.pmForklift.repair.delivered,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pmForklift.repair,
                                      "delivered",
                                      $$v
                                    )
                                  },
                                  expression: "pmForklift.repair.delivered",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Forklift comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.pmForkliftComment,
                                  callback: function ($$v) {
                                    _vm.pmForkliftComment = $$v
                                  },
                                  expression: "pmForkliftComment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        {
                          staticClass: "mb-1",
                          attrs: {
                            label: "Yard",
                            "custom-class": "is-large mb-1",
                            grouped: "",
                          },
                        },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Clean rejected to dirty" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.pmForklift.park.cleanRejectedDirty,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pmForklift.park,
                                      "cleanRejectedDirty",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pmForklift.park.cleanRejectedDirty",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Rejected Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value:
                                    _vm.pmForklift.park
                                      .cleanRejectedDirtyComment,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pmForklift.park,
                                      "cleanRejectedDirtyComment",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pmForklift.park.cleanRejectedDirtyComment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { staticClass: "mb-1", attrs: { grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Clean rejected to repair" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value:
                                    _vm.pmForklift.park.cleanRejectedRepair,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pmForklift.park,
                                      "cleanRejectedRepair",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pmForklift.park.cleanRejectedRepair",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Rejected Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value:
                                    _vm.pmForklift.park
                                      .cleanRejectedRepairComment,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pmForklift.park,
                                      "cleanRejectedRepairComment",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pmForklift.park.cleanRejectedRepairComment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { staticClass: "mb-1", attrs: { grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Dirty rejected to repair" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value:
                                    _vm.pmForklift.park.dirtyRejectedRepair,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pmForklift.park,
                                      "dirtyRejectedRepair",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pmForklift.park.dirtyRejectedRepair",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Rejected Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value:
                                    _vm.pmForklift.park
                                      .dirtyRejectedRepairComment,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pmForklift.park,
                                      "dirtyRejectedRepairComment",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pmForklift.park.dirtyRejectedRepairComment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.operation === "forklift" && _vm.shift === "Night"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        {
                          staticClass: "mb-1",
                          attrs: {
                            label: "Dirty",
                            "custom-class": "is-large mb-1",
                            grouped: "",
                          },
                        },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Received" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.nightForklift.dirty.received,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.nightForklift.dirty,
                                      "received",
                                      $$v
                                    )
                                  },
                                  expression: "nightForklift.dirty.received",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Delivered" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.nightForklift.dirty.delivered,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.nightForklift.dirty,
                                      "delivered",
                                      $$v
                                    )
                                  },
                                  expression: "nightForklift.dirty.delivered",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        {
                          staticClass: "mb-1",
                          attrs: {
                            label: "Clean",
                            "custom-class": "is-large mb-1",
                            grouped: "",
                          },
                        },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Received" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.nightForklift.clean.received,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.nightForklift.clean,
                                      "received",
                                      $$v
                                    )
                                  },
                                  expression: "nightForklift.clean.received",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Delivered" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.nightForklift.clean.delivered,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.nightForklift.clean,
                                      "delivered",
                                      $$v
                                    )
                                  },
                                  expression: "nightForklift.clean.delivered",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        {
                          staticClass: "mb-1",
                          attrs: {
                            label: "Repair",
                            "custom-class": "is-large mb-1",
                            grouped: "",
                          },
                        },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Received" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.nightForklift.repair.received,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.nightForklift.repair,
                                      "received",
                                      $$v
                                    )
                                  },
                                  expression: "nightForklift.repair.received",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Delivered" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.nightForklift.repair.delivered,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.nightForklift.repair,
                                      "delivered",
                                      $$v
                                    )
                                  },
                                  expression: "nightForklift.repair.delivered",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Forklift comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.nightForkliftComment,
                                  callback: function ($$v) {
                                    _vm.nightForkliftComment = $$v
                                  },
                                  expression: "nightForkliftComment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        {
                          staticClass: "mb-1",
                          attrs: {
                            label: "Yard",
                            "custom-class": "is-large mb-1",
                            grouped: "",
                          },
                        },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Clean rejected to dirty" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value:
                                    _vm.nightForklift.park.cleanRejectedDirty,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.nightForklift.park,
                                      "cleanRejectedDirty",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "nightForklift.park.cleanRejectedDirty",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Rejected Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value:
                                    _vm.nightForklift.park
                                      .cleanRejectedDirtyComment,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.nightForklift.park,
                                      "cleanRejectedDirtyComment",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "nightForklift.park.cleanRejectedDirtyComment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { staticClass: "mb-1", attrs: { grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Clean rejected to repair" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value:
                                    _vm.nightForklift.park.cleanRejectedRepair,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.nightForklift.park,
                                      "cleanRejectedRepair",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "nightForklift.park.cleanRejectedRepair",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Rejected Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value:
                                    _vm.nightForklift.park
                                      .cleanRejectedRepairComment,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.nightForklift.park,
                                      "cleanRejectedRepairComment",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "nightForklift.park.cleanRejectedRepairComment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { staticClass: "mb-1", attrs: { grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Dirty rejected to repair" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value:
                                    _vm.nightForklift.park.dirtyRejectedRepair,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.nightForklift.park,
                                      "dirtyRejectedRepair",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "nightForklift.park.dirtyRejectedRepair",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Rejected Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value:
                                    _vm.nightForklift.park
                                      .dirtyRejectedRepairComment,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.nightForklift.park,
                                      "dirtyRejectedRepairComment",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "nightForklift.park.dirtyRejectedRepairComment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.operation === "special" && _vm.shift === "AM"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        { attrs: { grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Number" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.amSpecialCrates,
                                  callback: function ($$v) {
                                    _vm.amSpecialCrates = $$v
                                  },
                                  expression: "amSpecialCrates",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.amSpecialComment,
                                  callback: function ($$v) {
                                    _vm.amSpecialComment = $$v
                                  },
                                  expression: "amSpecialComment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.operation === "special" && _vm.shift === "PM"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        { attrs: { grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Number" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.pmSpecialCrates,
                                  callback: function ($$v) {
                                    _vm.pmSpecialCrates = $$v
                                  },
                                  expression: "pmSpecialCrates",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.pmSpecialComment,
                                  callback: function ($$v) {
                                    _vm.pmSpecialComment = $$v
                                  },
                                  expression: "pmSpecialComment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.operation === "special" && _vm.shift === "Night"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-field",
                        { attrs: { grouped: "" } },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Number" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.nightSpecialCrates,
                                  callback: function ($$v) {
                                    _vm.nightSpecialCrates = $$v
                                  },
                                  expression: "nightSpecialCrates",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.nightSpecialComment,
                                  callback: function ($$v) {
                                    _vm.nightSpecialComment = $$v
                                  },
                                  expression: "nightSpecialComment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("footer", { staticClass: "modal-card-foot" }, [
            _c(
              "button",
              {
                staticClass: "button is-info is-fullwidth",
                on: { click: _vm.submit },
              },
              [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }